module.exports = __webpack_public_path__ + "static/media/Lunasima-Regular.0eb11732.ttf";